<template>
  <SimilarPatents
    :tech-path-description="techPathDescription"
    :tech-path-id="techPathId"
    :problem-description="problemDescription"
    :project-id="projectId"
    @back="handleBack"
  />
</template>

<script setup>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import SimilarPatents from '@/components/SimilarPatents.vue'

const route = useRoute()
const router = useRouter()

const techPathDescription = computed(() => String(route.query.techPathDescription || ''))
const techPathId = computed(() => route.query.pathId || null)
const problemDescription = computed(() => String(route.query.problemDescription || ''))
const projectId = computed(() => route.query.projectId || null)

const handleBack = () => {
  if (window.history.length > 1) {
    router.back()
  } else {
    window.close()
  }
}
</script>
